import "./DesignTool.0.css";
import Draggable from 'vuedraggable';
import { mapCompProp, designToolMixin } from "../../../../lib/helpers";
import { clamp, range } from "lodash-es";
import { addTabPane, deleteTabPane } from './actions';
import { vueDeepAssign } from "../../../../lib/utils/vue";
const __script_base__ = {
  name: 'TabsDesignTool',
  mixins: [designToolMixin],
  components: {
    Draggable
  },
  computed: {
    defaultTabIndex: mapCompProp('cur'),
    // 不要直接用
    compInstance() {
      return this.getCompInstance();
    },
    cur: {
      get() {
        return clamp(this.compInstance.current, 0, this.dragIndices.length - 1);
      },
      set(v) {
        this.compInstance.current = v;
      }
    },
    dragIndices() {
      var _this$comp$children;
      return range(((_this$comp$children = this.comp.children) === null || _this$comp$children === void 0 ? void 0 : _this$comp$children.length) || 0);
    }
  },
  methods: {
    getTabs() {
      var _this$compInstance;
      return ((_this$compInstance = this.compInstance) === null || _this$compInstance === void 0 ? void 0 : _this$compInstance.allTabs) || [];
    },
    renameTab(index) {
      this.modifyComp(comp => {
        const target = comp.children[index];
        if (!target) return;
        if (!target.props) target.props = {};
        const newTitle = prompt('请输入页卡标题', target.props.title || '');
        if (typeof newTitle === 'string') target.props.title = newTitle;
      });
    },
    async deleteTabPane(index) {
      await this.modifyComp(c => deleteTabPane(c, index));
    },
    async handleDragEnd({
      oldIndex,
      newIndex
    }) {
      const wasDefault = this.defaultTabIndex === oldIndex;

      // 修改 Layout 里的 children
      await this.modifyComp(comp => {
        const temp = comp.children.splice(oldIndex, 1);
        comp.children.splice(newIndex, 0, ...temp);
        if (wasDefault) vueDeepAssign(comp, {
          props: {
            cur: newIndex
          }
        });
      });

      // 修改目前预览的组件。因为 children 里的顺序变了，但是 key 还一致的话，是不会触发 allTabs 更新的
      this.compInstance.syncAllTabs();
      this.compInstance.current = newIndex;
    },
    handleTabClick(idx) {
      if (this.cur !== idx) this.cur = idx;else this.defaultTabIndex = idx;
    },
    async addTabPane() {
      let newIndex;
      await this.modifyComp(c => {
        newIndex = addTabPane(c);
      });
      this.cur = newIndex;
    }
  }
};
var render = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c('draggable', {
    staticClass: "uc-tabs-list uc-tabs-designTool",
    attrs: {
      "value": _vm.dragIndices,
      "draggable": ".isDesignToolDraggable",
      "animation": 300
    },
    on: {
      "end": _vm.handleDragEnd
    },
    nativeOn: {
      "dragstart": function ($event) {
        $event.stopPropagation();
      }
    }
  }, [_vm._l(_vm.getTabs(), function (ref, index) {
    var title = ref.title;
    var badgeText = ref.badgeText;
    return _c('div', {
      key: index,
      staticClass: "uc-tabs-item isDesignToolDraggable",
      class: {
        isActive: index === _vm.cur,
        isDefault: index === _vm.defaultTabIndex
      },
      attrs: {
        "tabindex": "0",
        "data-index": index
      },
      on: {
        "click": function ($event) {
          return _vm.handleTabClick(index);
        }
      }
    }, [_c('div', {
      staticClass: "uc-tabs-item-text"
    }, [_vm._v("\n      " + _vm._s(title) + "\n      "), badgeText ? _c('div', {
      staticClass: "uc-tabs-item-badge"
    }, [_vm._v("\n        " + _vm._s(badgeText) + "\n      ")]) : _vm._e()]), _vm._v(" "), _c('div', {
      staticClass: "uc-tabs-item-actionWrapper"
    }, [_c('div', {
      staticClass: "uc-tabs-item-action"
    }, [_c('i', {
      staticClass: "fa fa-edit",
      attrs: {
        "title": "修改标题"
      },
      on: {
        "click": function ($event) {
          return _vm.renameTab(index);
        }
      }
    }), _vm._v(" "), _c('i', {
      staticClass: "fa fa-trash",
      attrs: {
        "title": "删除页卡"
      },
      on: {
        "click": function ($event) {
          return _vm.deleteTabPane(index);
        }
      }
    })])])]);
  }), _vm._v(" "), _c('div', {
    staticClass: "uc-tabs-item isDesignToolPlus",
    attrs: {
      "slot": "footer"
    },
    on: {
      "click": _vm.addTabPane
    },
    slot: "footer"
  }, [_c('i', {
    staticClass: "fa fa-plus"
  })])], 2);
};
var staticRenderFns = [];
const __script__ = __script_base__;
export default Object.assign({
  render,
  staticRenderFns,
  _compiled: true
}, {
  "__file": "builtin/components/Tabs/DesignTool.vue"
}, typeof __script__ === 'function' ? __script__.options : __script__);